import {Injectable, Inject} from 'ng-metadata/core';
import {ConfigurationUtil} from '../../nddUtils/configurationUtil.service';
import {MappingTablesCache} from '../../mappingTablesCache/mappingTablesCache.service';
import {
    getAttributesMap,
    getVid,
    getInstitutionCode,
    isNgrs,
    getPrimoVeDeliveryBulkFromBrief,
    getPrimoVeBriefResultsJournalCoverage,
    getIsSupposedToCalcPhysicalServiceIdForExternalRecord
} from '../../appConfig/appConfigForward';
import {FullViewLinksService} from './links/serviceLinks.service';
import {RtaService} from '../rta.service';
import {LocationService} from './getit/opac/locations/location/location.service';
import {RecordUtil} from '../../infra/RecordUtil.service';
import {PrimoResponse} from '../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {CitationTrailsFullviewLinkService} from '../citationTrails/citationTrailsFullviewLink.service';
import {TimesCitedService} from "../timesCited/timesCited.service";
import {NewspapersService} from '../../newspapers/newspapers.service';
import {STATE_NAMES} from "../../primoExplore/primoExploreStates.module";
import {MoreLikeThisService} from "../moreLikeThis/moreLikeThis.service";
import {CollectionDiscoveryService} from "../../collectionDiscovery/collectionDiscovery.service";
import {UserSessionManagerService} from '../../security/userSessionManager.service';
import {PrimolyticsService, beacon} from '../../analytics/primolytics.service';
import { PrimoPayloads } from '../../infra/dataStructures/PrimoPayloads/edelivery.interface';
import { JwtUtilService } from '../../security/jwtUtil.service';
import {AuthoritySearchService} from "../authority/authoritySearch.service";
const get = require('lodash/get');

var angular: angular.IAngularStatic = require('angular');
const findIndex = require('lodash/findIndex');
const indexOf = require('lodash/indexOf');
const _get = require('lodash/get');
let union = require('lodash/union');
const uniqBy = require('lodash/uniqBy');
const find = require('lodash/find');
const forEach = require('lodash/forEach');
const _cloneDeep = require('lodash/cloneDeep');
const GS_STRING_DELIMITER = ";";

@Injectable()
export class FullViewService {
    public servicesDirectives: Object;
    private services: Object;
    public servicesArray: Object;
    private vid: string = getVid();
    private calculateSvcIdDone: boolean = false;
    private calculatePcDeliveryDone: boolean = false;
    private _calculatePrimaViewItDeliveryDone: boolean = false;
    private displaySearchWithinJournal: boolean;
    private _lang3: string;
    private isVirtualBrowseDisabled: boolean = false;
    public nextOffset: Object = {};
    public totalItems: Object = {};
    public moreLikeThisItems: Object = {};
    public moreLikeThisUnfilteredItems: Object = {};
    public isPromiseResolved: boolean =false;
    private viewitDeliveryCategories = ['Alma-E', 'Alma-D', 'Alma-C', 'Remote Search Resource'];
    
    private servicesToFilter = ['details', 'reviewsandtags', 'esploroUsage','onlinereviews', 'browseshelf', 'moreLikeThisCourse', 'moreLikeThisCollection'];
    private authorityServices = ['brief', 'action_list', 'details', 'links'];
    private genresForViewItrelatedServices = ['journal', 'article', 'issue'];
    public viewOnlineScrollId: string;


    constructor(private collectionDiscoveryService: CollectionDiscoveryService,
                private userSessionManagerService: UserSessionManagerService,
                private jwtUtilService: JwtUtilService,
                @Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs: Object,
                private configurationUtil: ConfigurationUtil,
                @Inject('$state') private $state: ng.ui.IStateService,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$translate') private $translate: ng.translate.ITranslateService,
                @Inject('$q') private $q: ng.IQService,
                private mappingTablesCache: MappingTablesCache,
                private linksService: FullViewLinksService,
                private rtaService: RtaService,
                private locationService: LocationService,
                private recordUtil: RecordUtil,
                private citationTrailsFullviewLinkService: CitationTrailsFullviewLinkService,
                private timesCitedService: TimesCitedService,
                private moreLikeThisService: MoreLikeThisService,
                private authoritySearchService: AuthoritySearchService,
                private newspapersService: NewspapersService) {
        this.configurationUtil = configurationUtil;
        this.isVirtualBrowseDisabled = (this.mappingTablesCache.getTable(this.mappingTablesCache.tables.VIEW_PROPERTIES).
                filter((row) => row.source1 === this.vid && row.source2 === 'disable_virtual_browse' && row.target === 'true').length === 1);
        this.servicesDirectives = {
            'brief': {
                scrollId: 'brief',
                serviceName: 'brief',
                title: 'nui.brief.results.tabs.brief'
            },
            'citations': {
                scrollId: 'citationTrails',
                serviceName: 'citationTrails',
                title: 'citation_trail.link.citations',
                conditional: (item: PrimoResponse.IDoc) => {
                    return (this.recordUtil.hasCitationTrails(item) && this.citationTrailsFullviewLinkService.shouldDisplayCitationTrial()) || this.citationTrailsFullviewLinkService.shouldDisplayTimesCited();
                }
            },
            'action_list': {
                scrollId: 'action_list',
                serviceName: 'action_list',
                title: 'nui.brief.results.tabs.send_to'
            },
            'esploroUsage': {
                scrollId: 'esploroUsage',
                serviceName: 'esploroUsage',
                title: 'nui.brief.results.tabs.esploroUsage'
            },
            'getit_link2': {
                serviceName: 'getit_link2', title: 'Get it 2'
            },
            'getit_link1': {
                scrollId: 'getit_link1',
                serviceName: 'getit_link1',
                title: 'brief.results.tabs.locations'
            },
            'tags': {
                scrollId: 'tags',
                serviceName: 'tags',
                title: 'brief.results.tabs.tags'
            },
            'rapidoOffer': {
                scrollId: 'rapidoOffer',
                serviceName: 'rapidoOffer',
                title: 'brief.results.tabs.Get_it_from_other_locations',
                conditional: (item: PrimoResponse.IDoc) => {
                    return !this.hideRapidoSectionBasedOnUserGroup();
                }
            },
            'quickAccess': {
                scrollId: 'quickAccess',
                serviceName: 'quickaccess',
                title: 'nui.brief.results.tabs.quickAccess'
            },
            'details': {
                scrollId: 'details',
                serviceName: 'details',
                title: 'brief.results.tabs.details'
            },
            'links': {
                scrollId: 'links',
                serviceName: 'links',
                title: 'nui.brief.results.tabs.links'
            },
            'browseshelf': {
                scrollId: 'virtualBrowse',
                serviceName: 'virtualBrowse',
                title: 'brief.results.tabs.browseshelf'
            },
            'moreLikeThisCourse': {
                scrollId: 'moreFromTheSameCourse',
                serviceName: 'moreLikeThisCourse',
                title: 'nui.brief.results.tabs.courseTab',
                tabTitle: 'nui.brief.results.tabs.moreCourse',
                conditional: (item: PrimoResponse.IDoc) => {
                    return getAttributesMap().moreLikeCourse ? getAttributesMap().moreLikeCourse : false;
                }
            },
            'moreLikeThisCollection': {
                scrollId: 'moreFromTheSameCollection',
                serviceName: 'moreLikeThisCollection',
                title: 'nui.brief.results.tabs.collectionTab',
                tabTitle: 'nui.brief.results.tabs.moreCollection',
                conditional: (item: PrimoResponse.IDoc) => {
                    return getAttributesMap().moreLikeCollection ? getAttributesMap().moreLikeCollection : false;
                }
            },
            'searchWithinJournal': {
                scrollId: 'searchWithinJournal',
                serviceName: 'searchWithinJournal',
                title: 'brief.results.tabs.searchWithinJournal'
            }, 
            'timesCited': {
                scrollId: 'citationTrails',
                serviceName: 'timesCited',
                title: 'citation_trail.link.citations',
                conditional: (item: PrimoResponse.IDoc) => {
                    return this.timesCitedService.shouldDisplayTimesCited;
                }
            },
            'mayAlsoBeFoundAt': {
                scrollId: 'mayAlsoBeFoundAt',
                serviceName: 'mayAlsoBeFoundAt',
                title: 'nui.brief.results.tabs.mayAlsoBeHeldByTab',
                tabTitle: 'nui.brief.results.tabs.mayAlsoBeFoundAt',
                conditional: (item: PrimoResponse.IDoc) => {
                    return getAttributesMap().mayAlsoBeHeldByEnabled ? getAttributesMap().mayAlsoBeHeldByEnabled : false;
                }
            }
//                                        'reviewsandtags'  : {'<prm-customization-iframe url-template-id="fullViewUrl"></prm-customization-iframe>'},

//                    'recommendations': {},
//                    'citations': {},
//                    'onlinereviews': {},
//                    'browseshelf': {}
        };

        this.services = [];
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            let index = this.servicesToFilter.indexOf('details');
            if (index > -1) {
                this.servicesToFilter.splice(index, 1);
            }
        }
        this.calculateSvcIdDone = false;
        this.calculatePcDeliveryDone = false;

    }

    public async getServices(item: PrimoResponse.IDoc, originator: string, haveNewDelivery?: boolean) {
        if (!this.servicesArray || haveNewDelivery || _get(item, 'delivery.links')) {
            return this.updateServices(item, originator, haveNewDelivery);
        }
        return this.servicesArray;
    }

    public isDisplayAllLinksEnabledInPrimo() {
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES,
            {source1: getVid(), source2: 'display_all_links', target: 'true'}).length > 0  // OTB false 
    }

    public isFullTextMultValue(item: PrimoResponse.IDoc){
        return get(item, 'pnx.delivery.fulltext[0]') === "fulltext_multiple";
    }

    get lang3(): string {
        return this._lang3;
    }

    set lang3(value: string) {
        this._lang3 = value;
    }

    public hideRapidoSectionBasedOnUserGroup(){
        let hideWhenNotLoggedIn = window.appConfig['system-configuration'].rapido_hide_section_when_user_not_logged_in;
        let userGroupsToHideFrom = window.appConfig['system-configuration'].rapido_hide_get_it_user_groups;
        let currentUserGroup = this.jwtUtilService.getDecodedToken().userGroup ? this.jwtUtilService.getDecodedToken().userGroup : undefined;
        let isGuestUser = !this.userSessionManagerService.getUserName();
        if(isGuestUser){
            return hideWhenNotLoggedIn;
        }
        return currentUserGroup in userGroupsToHideFrom;
    }

    public updateMetadataViewStatistics(item: PrimoResponse.IDoc, instCode: string) {
        let statisticsParams = {
            'mmsid': item.pnx.display.mms[0],
            'inst': instCode,
            'title': item.pnx.display.title[0] 
        };
        let httpConfig = {
            method: 'PUT',
            url: this.restBaseURLs.updateStatistics +'/metadataView',
            params: statisticsParams 
        };
        let _this = this;
        this.$http(httpConfig)
            .then((response) => {
            })
            .finally(() => {                
            });
        }

    public updateServices(item: PrimoResponse.IDoc, originator: string, haveNewDelivery?: boolean) {
        if (this.isCall && !haveNewDelivery) {
            return;
        }
        this.isCall =true;
        this.lang3 = item.lang3;
        let tabsOrder = this.configurationUtil.getBriefResultConfiguration().tabsorder.items.split(',');
        let services = tabsOrder
            .filter((value, index, arr) => this.servicesDirectives[value])
            .map((value, index, arr) => {
                return this.servicesDirectives[value];
            });
        if(tabsOrder.indexOf('moreFromTheSame') >= 0){
            tabsOrder.splice(tabsOrder.indexOf('moreFromTheSame'),1,'moreLikeThisCourse','moreLikeThisCollection');

        }
        let orderedTabsConf = tabsOrder.map((key) => {return _get(this.servicesDirectives,key);}).filter(Boolean);
        let promisesArr = [];
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            services = this.handleCitationTrialsAndTimesCitedVisibilityForSuprima(services, this.citationTrailsFullviewLinkService, this.timesCitedService);
        }
        let getItExpanded = this.parseServicesWithConfiguration(item, 'getit_link1');
        let getIt2Expanded = this.parseServicesWithConfiguration(item, 'getit_link2');
        let servicesToDisplay =
            [this.parseServicesWithConfiguration(item, 'brief')]
                .concat([this.parseServicesWithConfiguration(item, 'action_list')])
                .concat(services);

        if (!this.configurationUtil.isSuprima() && !(this.newspapersService.isNewspapersSearch() || this.newspapersService.isNewspaperItem(item))) {
            servicesToDisplay = servicesToDisplay.concat([this.parseServicesWithConfiguration(item, 'tags')]);
        } else {
            let mainMenuConfiguration = this.configurationUtil.getMainMenuConfiguration();
            let tags = find(mainMenuConfiguration.mainview, (e) => e.label === 'tags');
            if (!tags || this.configurationUtil.getSummonOverAlma()
                || this.configurationUtil.getDiscoveryServicesPage() || this.configurationUtil.getDiscoveryLocalNoLogin() || this.configurationUtil.getDiscoveryWithExternalNoLogin()
            ) {
                let tagsIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'tags');
                servicesToDisplay.splice(tagsIndex, 1);
            }
        }

        if(this.authoritySearchService.isAuthorityState()){
            servicesToDisplay = servicesToDisplay.filter(svc => this.authorityServices.find(authSvc => authSvc === svc.serviceName));
        }

        if (!this.showQuickAccess(item)){
        servicesToDisplay = servicesToDisplay.filter((value, index, arr) => value.serviceName !== 'quickaccess');
         }
        // More Like This Service

        // Course
        if (_get(item, 'pnx.search.crsid') || _get(item, 'pnx.display.crsinfo')) {
            let courseConf = this.parseServicesWithConfiguration(item, 'moreLikeThisCourse');
            if(courseConf.conditional(item)){
                promisesArr.push(this.moreLikeThisService.getItemsForSameField(item, 'crs').then((response) => {
                    this.setResultFields(response, item, 'crs');
                    if (this.moreLikeThisItems['crs'] && this.moreLikeThisItems['crs'].length > 0) {
                        let insertIndex = this.getInsertIndexLateService(orderedTabsConf,servicesToDisplay,courseConf);
                        servicesToDisplay.splice(insertIndex,0,courseConf);
                    } else {
                        servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCourse');
                        this.setResultFields(undefined, item, 'moreLikeThisCourse');
                    }
    
                }, (rej) => {
                }).finally(() => {
                    this.moreLikeThisService.itemsSearchInProgress = false;
                }));
            }
        } else {
            servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCourse');
            this.setResultFields(undefined, item, 'moreLikeThisCourse');
        }

        // Collection
        if (_get(item, 'pnx.search.cdparentid')  || _get(item, 'pnx.control.colldiscovery')) {
            let collectionConf = this.parseServicesWithConfiguration(item, 'moreLikeThisCollection');
            if(collectionConf.conditional(item)){
                promisesArr.push(this.moreLikeThisService.getItemsForSameField(item, 'col').then((response) => {
                    this.setResultFields(response, item, 'col');
                    if (this.moreLikeThisItems['col'] && this.moreLikeThisItems['col'].length > 0) {
                        let insertIndex = this.getInsertIndexLateService(orderedTabsConf,servicesToDisplay,collectionConf);
                        servicesToDisplay.splice(insertIndex,0,collectionConf);
                    } else {
                        servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCollection');
                        this.setResultFields(undefined, item, 'moreLikeThisCollection');
                    }
                }, (rej) => {
                }).finally(() => {
                    this.moreLikeThisService.itemsSearchInProgress = false;
                }));
            }
        } else {
            servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'moreLikeThisCollection');
            this.setResultFields(undefined, item, 'moreLikeThisCollection');
        }

        let isCallNumberEmpty = true;
        if (get(getAttributesMap(),['virtualBrowseType'],'shelf')==='shelf'){
            isCallNumberEmpty = (get(item,"enrichment.virtualBrowseObject.callNumberBrowseField",'') === '');
        }else if (get(getAttributesMap(),['virtualBrowseType'],'shelf')==='bib'){
            isCallNumberEmpty = (get(item,"enrichment.bibVirtualBrowseObject.callNumberBrowseField",'') === '');
        }

        // More Like This Service - End
        if ( isCallNumberEmpty ||
            !((get(item,"enrichment.virtualBrowseObject.isVirtualBrowseEnabled",false) && !this.isVirtualBrowseDisabled) ||
               (get(getAttributesMap(),['virtualBrowseType'],'shelf')==='bib' && get(item,"enrichment.bibVirtualBrowseObject.isVirtualBrowseEnabled",false))) ) {        
            servicesToDisplay = servicesToDisplay.filter(svc => svc.serviceName !== 'virtualBrowse');
        }

        if (this.configurationUtil.getBackendSystem() !== 'suprima') {
            if (this.linksService.hasLinks(item)) {
                let detailsServiceIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'details');
                servicesToDisplay.splice(detailsServiceIndex + 1, 0, this.parseServicesWithConfiguration(item, 'links'));
            }
        } else {
            let linksServiceIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'links');
            if (linksServiceIndex != -1) {
                if (!this.linksService.hasLinks(item)) {
                    servicesToDisplay[linksServiceIndex].isHidden = true;
                }
                else {
                    servicesToDisplay[linksServiceIndex].isHidden = false;
                }
            }
        }

        let index = findIndex(servicesToDisplay, (obj) => obj.serviceName === 'getit_link1');
        servicesToDisplay = servicesToDisplay.filter(
            (value, index, arr) => value.serviceName !== 'getit_link1'
        );
        servicesToDisplay = servicesToDisplay.slice(0, index)
            .concat(getItExpanded)
            .concat(servicesToDisplay.slice(index));

        if (angular.isDefined(getIt2Expanded)) {
            let changed = false;
            for (let i = 0; i < servicesToDisplay.length; i++) {
                if (servicesToDisplay[i].serviceName == "getit_link2") {
                    servicesToDisplay[i] = getIt2Expanded[0];
                    changed = true;
                    break;
                }
            }
            if (!changed) {
                servicesToDisplay = servicesToDisplay.concat(getIt2Expanded);
            }
        } else {
            servicesToDisplay = servicesToDisplay.filter((obj) => {
                return obj.serviceName != "getit_link2"
            })
        }


        //if current state is services page, filter the unneedded services that are defined in servicesToFilter
        if (this.$state.current.name === STATE_NAMES.SERVICE_PAGE) {
            servicesToDisplay = servicesToDisplay.filter((value) =>
                findIndex(this.servicesToFilter, (obj) => obj === value.serviceName) < 0
            );
            if (this.configurationUtil.getBackendSystem() === 'suprima') {
                if (!this.configurationUtil.getSummonOverAlma() || !this.isLocalRecord(item)) {
                    let detailsServiceIndex = findIndex(servicesToDisplay, (s) => s.serviceName === 'details');
                    servicesToDisplay.splice(detailsServiceIndex, 1);
                }
            }
        }
        
        if ((this.configurationUtil.getBackendSystem() === 'suprima' && item.delivery && item.delivery.mayAlsoBeFoundAt === undefined) || 
        		this.configurationUtil.getBackendSystem() !== 'suprima') {              
            servicesToDisplay = servicesToDisplay.filter(value => value.serviceName !== 'mayAlsoBeFoundAt');
        } 
        
        if (this.$state.current.name === STATE_NAMES.RAPIDO_VIEWIT){
            servicesToDisplay = servicesToDisplay.filter(value => value.serviceName === 'Viewit');
        }
        
        if (!this.displaySearchWithinJournal) {
            servicesToDisplay = servicesToDisplay.filter(
                (value, index, arr) => value.serviceName !== 'searchWithinJournal'
            );
        }
        if(!isNgrs()){
            servicesToDisplay = servicesToDisplay.filter(
                (value, index, arr) => value.serviceName !== 'rapidoOffer'
            );
        }
        
        if(!this.isEsploroRecord(item)){
            servicesToDisplay = servicesToDisplay.filter(
                (value, index, arr) => value.serviceName !== 'esploroUsage'
            );
        }

        if (this.configurationUtil.getRapidoSAEnabled()) {
            // case of Rapido SA, need only some services
            let rapidoSAServices = this.rapidoSAServices();
            servicesToDisplay = servicesToDisplay.filter(serviceObj =>
                rapidoSAServices.some(rapidoSAService => rapidoSAService === serviceObj.serviceName)
            );
        }

        this.servicesArray = servicesToDisplay;
        return this.$q.all(promisesArr).then( () => {
            this.isCall =false;
            if (haveNewDelivery) {
            	   if (!this.showQuickAccess(item)){
            	         servicesToDisplay = servicesToDisplay.filter((value, index, arr) => value.serviceName !== 'quickaccess');
            	         }
                this.servicesArray = servicesToDisplay;
            }
            this.isPromiseResolved = true;
            return this.servicesArray;
        });        
    }
	private showQuickAccess(item){
		let isShowQuickAccess=false;
		 if (item.delivery && item.delivery.serviceMode){
 		for (let serviceMode of item.delivery.serviceMode){
 			if (serviceMode==="quickaccess"){
 				isShowQuickAccess=true;
 				break;
 			}
 		}
	}
 		return isShowQuickAccess;
	}
	
    private setResultFields(data, item, serviceName) {
        if (!data){
            this.nextOffset[serviceName] = undefined;
            this.totalItems[serviceName] = undefined;
            this.moreLikeThisItems[serviceName] = undefined;
            this.moreLikeThisUnfilteredItems[serviceName] = undefined;
        } else {
            this.nextOffset[serviceName] = _get(data, 'data.docs').length;
            let items = this.moreLikeThisService.parseResponse(data, item);
            this.totalItems[serviceName] = _get(data, 'data.info.total');
            this.moreLikeThisItems[serviceName] = items;
            this.moreLikeThisUnfilteredItems[serviceName] = get(data, 'data.docs') || get(data, 'docs');
        }
    }


    
    public isEsploroRecord(item) {
	    if (!this.isLocalRecord(item)){
	    	return false;
	    }
        let sourceformat = _get(item, 'pnx.control.sourceformat');
        if (angular.isArray(sourceformat)) {
            sourceformat = sourceformat[0];
        }
        if (sourceformat && sourceformat === 'ESPLORO') {
            return true;
        }
        return false;
    }
    
        private isLocalRecord(item) {
        let srcId = _get(item, 'pnx.control.sourceid');
        if (angular.isArray(srcId)) {
            srcId = srcId[0];
        }
        if (srcId === 'alma') {
            return true;
        }
        return false;
    }

    public setSearchWithinJournalService(item) {
        this.displaySearchWithinJournal = false;
        if (this.configurationUtil.getBackendSystem() !== 'suprima') {
            return;
        }
        let issn = _get(item, 'pnx.addata.issn[0]', undefined);
        let eissn = _get(item, 'pnx.addata.eissn[0]', undefined);
        if (!(issn || eissn)) {
            return;
        }
        if (!this.isResourceTypeJournal(item)){
            return;
        }
        if (this.configurationUtil.getBackendSystem() === 'suprima' && this.configurationUtil.getDiscoveryServicesPage()){
            return;
        }
        let config = this.configurationUtil.getSearchWithinJournalConfig();
        if (this.configurationUtil.getSummonOverAlma()) {
            if (!config.summonUrl) {
                return;
            }
        } else if (!(config.tab && config.scope)) {
            return;
        }
        this.displaySearchWithinJournal = true;
    }

    private isResourceTypeJournal(item) : boolean{
        let rtype = _get(item, 'pnx.display.type[0]', '');
        let jTitle = _get(item, 'pnx.addata.jtitle[0]');
        let aTitle = _get(item, 'pnx.addata.atitle[0]');
        let bTitle = _get(item, 'pnx.addata.btitle[0]');
        let format = _get(item, 'pnx.addata.format[0]');
        let genre = _get(item, 'pnx.addata.genre[0]');
        return (rtype.toLowerCase().startsWith('journal')) ||
            (jTitle && !bTitle && !aTitle) ||
            (format === 'journal' && genre === 'journal');
    }

    public isCalculatePcDeliveryDone() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            return this.calculatePcDeliveryDone;
        }
        return true;
    }

    public isCalculateSvcIdDone() {
        if (this.configurationUtil.getBackendSystem() === 'suprima') {
            return this.calculateSvcIdDone;
        }
        return true;
    }

    public suprimaEnrichers(item) {
        this.calculatePhysicalServiceId(item);
        this.enrichDeliveryWithERTA(item);
		this.saveCtxObjForAnalytics(item);
        this.calculatePcDelivery(item);
        this.addRecordToRemoteRecordTable(item);
        this.updateGoogleScholarUrls(item);
    }

    public googleScholarEnrich(pnx){
        if (pnx.control && pnx.control.sourceformat && pnx.control.sourceformat.length > 0 &&
            pnx.control.sourceformat[0] === 'ESPLORO'){
            this.googleScholarEnrichForEsploro(pnx);
        } else {
            this.googleScholarEnrichForDigital(pnx)
        }
    }

    public googleScholarEnrichForDigital(pnx){
        if (pnx.display.creator !== undefined){
            for (let creator of pnx.display.creator){
                this.addMeta("citation_author", creator);
            }
        }
        this.addMeta("citation_language", _get(pnx,'display.language[0]',undefined));
        this.addMeta("citation_title", _get(pnx,'display.title[0]',undefined));
        this.addMeta("citation_publisher", _get(pnx,'display.publisher[0]',undefined));
        this.addMeta("citation_publication_date", _get(pnx,'addata.date[0]',undefined));
    }

    public googleScholarEnrichForEsploro(pnx) {
    	var fullTitle = [pnx.display.title[0]];
    	if (pnx.display.title.length > 1){ 
    		fullTitle[0] = fullTitle[0] + ": " + pnx.display.title[1];
    	}
        this.googleScholarEnrichHandleField("citation_title", fullTitle, false, true);
    	if (pnx.addata.authorsforgs && pnx.addata.authorsforgs.length > 0){
            this.googleScholarEnrichHandleField("citation_author", pnx.addata.authorsforgs, true, false);
        }

        if (this.isArticle(pnx)) {
            if (pnx.addata.jtitle == null || pnx.addata.jtitle == "") {
                this.googleScholarEnrichHandleField("citation_journal_title", pnx.display.partoftitle, false, true);
            } else {
                this.googleScholarEnrichHandleField("citation_journal_title", pnx.addata.jtitle, false, true);
            }
            this.googleScholarEnrichHandleField("citation_issn", pnx.addata.issn, false, false);
            this.googleScholarEnrichHandleField("citation_issn", pnx.addata.eissn, false, false);
            this.googleScholarEnrichHandleField("citation_volume", pnx.addata.volume, false, true);
            this.googleScholarEnrichHandleField("citation_issue", pnx.addata.issue, false, true);
            this.googleScholarEnrichHandleField("citation_firstpage", pnx.addata.spage, false, true);
            this.googleScholarEnrichHandleField("citation_lastpage", pnx.addata.epage, false, true);
        }

        if (this.isConference(pnx)){
            this.googleScholarEnrichHandleField("citation_conference_title", pnx.addata.atitle, false, true);
        }
        this.googleScholarEnrichHandleField("citation_doi", pnx.addata.doi, false, true);

        this.googleScholarEnrichHandleField("citation_isbn", pnx.addata.isbnforgs, false, false);
        this.googleScholarEnrichHandleField("citation_isbn", pnx.addata.eisbnforgs, false, false);

        this.googleScholarEnrichHandleField("citation_publication_date", pnx.addata.datepublishedforgs, false, true);
        this.googleScholarEnrichHandleField("citation_online_date", pnx.addata.dateepublishedforgs, false, true);

        if (pnx.addata.dissertationforgs && pnx.addata.dissertationforgs.length > 0){
            this.googleScholarEnrichHandleField("citation_dissertation_institution", pnx.addata.dissertationforgs,
                false, true);
        }

        this.googleScholarEnrichHandleField("citation_technical_report_institution", pnx.addata.aucorp, false, true);

        this.googleScholarEnrichHandleField("citation_language", pnx.display.language, false, true);
        this.googleScholarEnrichHandleField("citation_publisher", pnx.display.publisher, false, true);
    }

    private isArticle(pnx){
        if (pnx.addata && pnx.addata.esplororesourcetype && pnx.addata.esplororesourcetype.length > 0){
            const resourceType = pnx.addata.esplororesourcetype[0];
            if (resourceType === 'publication.journalArticle' || resourceType === 'publication.conferenceProceeding' ||
                resourceType === 'postedContent.acceptedManuscript' || resourceType === 'publication.bookReview'){
                return true;
            }
            return false;
        }
        return false;
    }

    private isConference(pnx){
        if (pnx.addata && pnx.addata.esplororesourcetype &&  pnx.addata.esplororesourcetype.length > 0){
            const resourceType = pnx.addata.esplororesourcetype[0];
            if (resourceType === 'conference.conferencePaper'){
                return true;
            }
            return false;
        }
        return false;
    }

    private googleScholarEnrichHandleField(tagName: String, location: any, subSplit: boolean, onlyFirst: boolean): Array<String> {
        let allElements = new Array<String>();
        if (location != null) {
            if (onlyFirst) {
                if (location[0] != null && location[0] != "") {
                    let element = this.googleScholarEnrichAddElement(tagName, location[0]);
                    if (element) {
                        allElements.push(element);
                    }
                }
            } else {
                for (let element of location) {
                    if (subSplit) {
                        for (let subElement of element.split(GS_STRING_DELIMITER)) {
                            if (subElement) {
                                let newSubElement: String = this.googleScholarEnrichAddElement(tagName, subElement);
                                if (newSubElement) {
                                    allElements.push(newSubElement);
                                }
                            }
                        }
                    } else {
                        let newElement: String = this.googleScholarEnrichAddElement(tagName, element);
                        if (newElement) {
                            allElements.push(newElement);
                        }
                    }
                }
            }
        }
        return allElements;
    }

    private googleScholarEnrichAddElement(tagName: String, element: String): String {
        let elementTrimmed: String = element.trimStart().trimEnd();
        this.addMeta(tagName, elementTrimmed);
        return elementTrimmed;
    }

    private isSupposedToCalcPhysicalServiceId(delivery): boolean {
        return getIsSupposedToCalcPhysicalServiceIdForExternalRecord() && delivery &&
            delivery.deliveryCategory.indexOf('Remote Search Resource') > -1;

    }

    private calculatePhysicalServiceId(item) {
        window.appPerformance.serverTimeLog = window.appPerformance.serverTimeLog?window.appPerformance.serverTimeLog:[];
        window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] = -1;
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || item.adaptor !== 'Local Search Engine') {
            this.calculateSvcIdDone = true;
            window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] = 0;            
            return;
        }
        let delivery = item.delivery;
        if (delivery) {
            if (delivery.physicalServiceId
            || (!this.hasHolding(delivery) && !this.isSupposedToCalcPhysicalServiceId(delivery))) {
            this.calculateSvcIdDone = true;
            window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] = 0;            
            return;
        }


        this.calculateSvcIdDone = false;
        let recordId = this.getIlsRecordId(item);
        let sourceRecordId = this.getSourceRecId(item);
        let resource_type = this.getResourceType(item);
        let httpConfig = {
            method: 'GET',
            url: this.restBaseURLs.calculatePhysicalServiceId + '/' + recordId + '?vid=' + this.vid + '&lang=' + this.$translate.use() + '&recordOwner=' + delivery.recordOwner + '&sourceRecordId=' + sourceRecordId + '&resource_type=' + resource_type+ '&isRapido=' + window.sessionStorage.getItem("isRapido"),
            params: null,
            data: null
        };
        let _this = this;
        this.$http(httpConfig)
            .then((response) => {
                _this.updatePhysicalServiceIdAndLinks(item, response.data);
                _this.updateServices(item);
                _this.calculateSvcIdDone = true;
                window.appPerformance.serverTimeLog['PhysicalServiceIdCalc'] = response.data.beaconO22;
            })
            .finally(() => {
                _this.calculateSvcIdDone = true;
            });
        }

    }

    private getIlsRecordId(item) {
        let delivery = item.delivery;
        if (get(delivery, 'holding[0].ilsApiId')) {
            return delivery.holding[0].ilsApiId;
        } else {
            return item.pnx.control.sourcerecordid[0];
        }
    }

    private getSourceRecId(item){
        return get(item, 'pnx.control.sourcerecordid[0]','');
    }
    private getResourceType(item){
        if(item && item.pnx && item.pnx.display && item.pnx.display.type && item.pnx.display.type[0]){
            return item.pnx.display.type[0];
        }
        return undefined;
    }

    private hasHolding(delivery) {
        if (delivery && delivery.holding && delivery.holding.length >= 1) {
            return true;
        } else if (delivery && this.hasPCategory(delivery.deliveryCategory)) {
            return true;
        }
        return false;
    }
    
    private skipDeliveryForRapido(item) {
    	if(!isNgrs()) {
    		return false;
    	}
    	let recordId = get(item, 'pnx.control.recordid'); 
        let rapidSourceRecordId = get(item,'pnx.control.rapidosourcerecordid');
        return recordId && rapidSourceRecordId;
    }
	
	public shouldCalculateRapidoLocalServices(item) {
		return !item.delivery && this.skipDeliveryForRapido(item);
	}
	
	public calculateLocalDeliveryForRapidoPerma(item) {
		let url = this.restBaseURLs.openUrl + "/rapidoDelivery/" + getInstitutionCode() + "/" + this.vid;
			let params = item;
			this.$http.post(url,params 
	            ).then((response) => {
	                item.delivery = response.data.delivery;
	            });
	}

    public addRecordToRemoteRecordTable(item) {

        try {
            if (this.configurationUtil.getBackendSystem() !== 'suprima'
                || (item.context !== 'WorldCat' && item.context !== 'SearchWebhook' && item.context !== 'Ebsco'  && item.context !== 'v2v' && item.context !== 'P2P')) {
                return;
            }

            let payload = {
                'context': item.context,
                'pnx': item.pnx,
                'recordId': item.pnx.control.recordid[0]
            };

            return this.$http.post(this.restBaseURLs.addToRemoteRecordTable, payload);
        }
        catch (Error) {
            console.log(Error.message);
        }
    }

    private calculatePcDelivery(item) {
        window.appPerformance.serverTimeLog = window.appPerformance.serverTimeLog?window.appPerformance.serverTimeLog:[];
        window.appPerformance.serverTimeLog['pcDelivery'] = -1;
        this.calculatePcDeliveryDone = false;
        
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || (item.adaptor !== 'Primo Central' && item.adaptor !== 'Primo VE Deep Search' && item.adaptor !== 'EbscoLocal' && item.adaptor !== 'WorldCatLocal' && item.adaptor !== 'SummonLocal' && item.adaptor !== 'SearchWebhook' && item.adaptor !== 'WEBHOOK'
            && (item.context !== 'SP')) || this.$state.current.name === STATE_NAMES.SERVICE_PAGE
            || (!item.delivery && this.skipDeliveryForRapido(item))	) {
            this.calculatePcDeliveryDone = true;
            window.appPerformance.serverTimeLog['pcDelivery'] = 0;
            return;
        }
        let delivery = item.delivery;
        if (delivery) {
        let payload = {
            'doc': item
        };
        let recordId = item.pnx.control.recordid[0];
        let httpConfig = {
            method: 'POST',
            url: this.restBaseURLs.calculatePcDelivery+'/'+encodeURI(recordId)+'?vid='+this.vid + '&lang=' + this.$translate.use(),
            params: null,
            data: payload
        };
        let _this = this;
        let almaInst = null;
        if (get(item, 'pnx.control.networklinkedrecordid')){
            almaInst = item.delivery.almaInstitutionsList;
        }
        this.$http(httpConfig)
            .then((response) => {
                if (item.adaptor === 'WorldCatLocal') {
                    let availability = _get(response, 'data.delivery.availability[0]');
                    if (availability === 'no_inventory') {
                        response.data.delivery.availability = item.delivery.availability;
                    }
                }
                item.delivery = response.data.delivery;
                if (almaInst){
                    item.delivery.almaInstitutionsList = almaInst;
                }
                _this.updateServices(item);
                _this.calculatePcDeliveryDone = true;
				window.appPerformance.serverTimeLog['pcDelivery'] = response.data.beaconO22;
            })
            .finally(() => {
                _this.calculatePcDeliveryDone = true;
            });
    }
    }

    private enrichDeliveryWithERTA(item : PrimoResponse.IDoc) {
        window.appPerformance.serverTimeLog = window.appPerformance.serverTimeLog?window.appPerformance.serverTimeLog:[];
		window.appPerformance.serverTimeLog['viewit'] = -1;
		
        this.calculatePrimaViewItDeliveryDone = false;
        let delivery = item.delivery;
        if (delivery) {

        // exit this method - dont do enrich, in the following cases::
        // (1) backend system is SUPRIMA
        // (2) there is no electronic category
        // (3) the electronicServices was already populated
        if (this.skipElectronicEnrich(item)) {
            this.calculatePrimaViewItDeliveryDone = true;
            window.appPerformance.serverTimeLog['viewit'] = 0;
            return;
        }
        
        let url = this.$location.url();
        let recordId = item.pnx.control.recordid[0];
        let vid = this.vid;
        let pnxGenre = _get(item, 'pnx.addata.genre[0]');
        let genreStr = '';
        if(pnxGenre !== undefined && pnxGenre != '' &&  this.genresForViewItrelatedServices.indexOf(pnxGenre) > -1){
            genreStr = '&genre=' + pnxGenre;
        }

        // The vid that ends with ':SD' is not a real vid and is used for cases where the services are available from external sources
        let institutionCode = _get(item, 'delivery.recordInstitutionCode');
        if (institutionCode && !this.hasECategory(delivery.deliveryCategory)) {
            vid = institutionCode + ":SD";
        }
        
        let payload = this.getEdeliveryPayload(item);
        let httpConfig = {
            method: 'POST',
            url: this.restBaseURLs.prepareElectorincRTA + '/' + recordId + '?vid=' + vid + '&lang=' + this.$translate.use() + genreStr,
            params: {'googleScholar': url.includes("tags=scholar")},
            data: payload
        };

        this.$http(httpConfig)
            .then(
                (response) => {
                    this.mergeDeliveryWithEDelivery(item, response.data, delivery.electronicServices !== null);
                    this.calculatePrimaViewItDeliveryDone = true;
                    this.updateServices(item);
                    this.updateGoogleScholarUrls(item);
					window.appPerformance.serverTimeLog['viewit'] = response.data.beaconO22;
                }
            ).finally(() => {
            this.calculatePrimaViewItDeliveryDone = true;
        });
    }

    }

    private saveCtxObjForAnalytics(item : PrimoResponse.IDoc) {
        // exit this method , in the following cases::
        // (1) backend system is SUPRIMA
        // (2) there is no electronic category
        let delivery = item.delivery;
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || item.context === 'SP' || item.adaptor === 'Primo Central' || item.adaptor === 'Primo VE Deep Search' || item.adaptor === 'EbscoLocal' || item.adaptor === 'WorldCatLocal'
            || (!this.hasEOrDOrRCategory(delivery.deliveryCategory) && !item.delivery.hasFilteredServices) 
            || !getPrimoVeDeliveryBulkFromBrief() || !getPrimoVeBriefResultsJournalCoverage()
            ) {
            return;
        }
        
        let url = this.$location.url();
        let recordId = item.pnx.control.recordid[0];
        let electronicContextObjectId = _get(item, 'delivery.electronicContextObjectId');
        let vid = this.vid;
        
        let httpConfig = {
            method: 'POST',
            url: this.restBaseURLs.saveToCtxService + '/' + recordId + '?vid=' + vid + '&electronicContextObjectId=' + electronicContextObjectId +  '&lang=' + this.$translate.use(),
        };

        this.$http(httpConfig)
            .then(
                (response) => {
                }
            ).finally(() => {
        });
    }

    
    private getEdeliveryPayload(item : PrimoResponse.IDoc){
        let payload : PrimoPayloads.Edelivery = {};
        payload.sharedDigitalCandidates = _get(item, 'delivery.sharedDigitalCandidates');
        return payload;
    }

    public updateAvailability(doc: PrimoResponse.IDoc) {
        if ((this.configurationUtil.getLocationsConfiguration() &&
            this.configurationUtil.getLocationsConfiguration().rta !== 'none')
            || (doc.delivery && doc.delivery.almaInstitutionsList)
        ) {
            doc.cameFrom = 'full';
            this.rtaService.updateAvailability([doc], {rtaOnAllInstitutions: 'true'});
        }
    }

    private skipElectronicEnrich(item) {
        let delivery = item.delivery;
        if (this.configurationUtil.getBackendSystem() !== 'suprima'
            || item.context === 'SP' || item.adaptor === 'Primo Central' || item.adaptor === 'Primo VE Deep Search' || item.adaptor === 'EbscoLocal' || item.adaptor === 'WorldCatLocal'
            || (!this.hasEOrDOrRCategory(delivery.deliveryCategory) && !item.delivery.hasFilteredServices && !this.hasCategory(delivery.deliveryCategory, 'Alma-E-temp'))
            || (delivery.edeliveryCalculated)) {
            return true;
        }
        return false;
    }

    private buildGetitServicesArray(item: PrimoResponse.IDoc, type: string): nui.IGetit1Service[] {
        if (!item) {
            return null;
        }
        let getItArray = this.getLinkByAction(item, type);

        let array = [];
        if (this.configurationUtil.isSuprima()) {
            //in case the e-delivery is not calculated yet but we know it exists so we need to have the viewIt tab at the time the page is loaded
            //this link will get overrided after the e-delivery is calculated
            let delCategories = item.delivery ? item.delivery.deliveryCategory : [];
            if (delCategories.indexOf('Alma-E') != -1 || delCategories.indexOf('Alma-D') != -1 || delCategories.indexOf('Remote Search Resource') != -1) {
                if (getItArray.filter(value => value.category === 'Alma-E' || value.category === 'Alma-D' ||  value.category === 'Remote Search Resource').length == 0) {
                    array.push(
                        {
                            scrollId: 'getit_link1_' + 0,
                            serviceName: 'Viewit',
                            title: 'nui.getit.service_viewit'
                        }
                    );
                }
            }
        }

        getItArray.forEach((value, index, arr) => {
            let delCategory = value.category;
            let delCategories = item.delivery ? item.delivery.deliveryCategory : [];
            let delIndex = indexOf(delCategories, delCategory);
            if (this.configurationUtil.isSuprima() && delIndex === -1 && this.isViewItDeliveryCategory(delCategory)) {
                delIndex = this.getViewItDeliveryIndex(delCategories);
            }
            let serviceName = '';
            if (delIndex !== -1 && item.delivery.serviceMode) {
                serviceName = item.delivery.serviceMode[delIndex];
            }
            if (value.links && value.links[0]) {
                let scrollIdIndex = array.length;
                if (serviceName === 'display') {
                    this.viewOnlineScrollId = 'getit_link1_' + scrollIdIndex;
                }
                array.push(
                    {
                        scrollId: 'getit_link1_' + scrollIdIndex,
                        serviceName: serviceName,
                        title: 'nui.getit.' + value.links[0].getItTabText,
                        linkElement: value
                    }
                );
            }
        });

        //Display locations even if there is no Getit1
        if (!this.configurationUtil.isSuprima()) {
            let getit1services = array.map(s => s.serviceName);
            if (indexOf(getit1services, 'ovp') === -1 &&
                indexOf(getit1services, 'ovl') === -1 &&
                indexOf(getit1services, 'activate') === -1) {
                let holdingArray = _get(item, 'delivery.holding', []);
                if (holdingArray && holdingArray.length > 0) {
                    array.push(
                        {
                            scrollId: 'getit_link1_' + array.length,
                            serviceName: this.locationService.isOvpLocation(holdingArray[0]) ? 'ovp' : 'ovl',
                            title: 'nui.getit.tab1_check',
                            linkElement: null
                        }
                    );
                }
            }
        }


        return array;
    }


    private buildGetit2ServicesArray(item: PrimoResponse.IDoc, type: string): nui.IGetit1Service[] {
        if (!item) {
            return null;
        }
        if (item.delivery && item.delivery.GetIt2) {
            let array: nui.IGetit2Service[] = [];
            let getit2 = item.delivery.GetIt2;
            getit2.hyperlinkText = getit2.getItTabText ? getit2.getItTabText : '';
            array.push(
                {
                    scrollId: 'getit_link2',
                    serviceName: getit2.serviceModeGetit2,
                    title: 'getit.' + getit2.getItTabText,
                    linkElement: {links: [getit2]}
                });

            return array;
        }
    }

    private hasEOrDOrRCategory(deliveryCategoryArray) {
        if (deliveryCategoryArray === null) {
            return false;
        }
        let categories = ['Alma-E', 'Alma-D', 'Remote Search Resource'];
        let found = deliveryCategoryArray.find((s) => categories.indexOf(s) >= 0);
        return (found !== undefined);
    }

    private hasCategory(deliveryCategoryArray, category) {
        if (deliveryCategoryArray === null) {
            return false;
        }
        let index = deliveryCategoryArray.indexOf(category);
        return (index >= 0);
    }

    private hasECategory(deliveryCategoryArray) {
        return this.hasCategory(deliveryCategoryArray, 'Alma-E');
    }

    private hasPCategory(deliveryCategoryArray) {
        return this.hasCategory(deliveryCategoryArray, 'Alma-P');
    }

    private mergeDeliveryWithEDelivery(item, eDelivery, isAlreadyCalculated) {
        let delivery = item.delivery;
        if (eDelivery!=null){
        	if(eDelivery.quickAccessService != null){
        		delivery.quickAccessService = eDelivery.quickAccessService;
        		eDelivery.serviceMode = eDelivery.serviceMode.concat('quickaccess');
        	}else{
        		let qaMode = findIndex(delivery.serviceMode, (sm) => sm === 'quickaccess');
        		if (qaMode !== -1) {
        			delivery.serviceMode.splice(qaMode, 1);
        		}
            }
        }
        if(eDelivery && eDelivery.filteredByGroupServices){
            delivery.filteredByGroupServices = eDelivery.filteredByGroupServices;
        }
        //Fix for URM-195140 - if record have get it from other, it will be displayed even if services
        //                     are hidden using DLR
        let almaInstitutionsList = get( delivery , 'almaInstitutionsList') || [];
        if (eDelivery === null || (!eDelivery.electronicServices && almaInstitutionsList.length == 0)) {
            //we initialy got alma-E, but it was removed with DisplayLogic, need to align the delivery
            let eDelCategory = findIndex(delivery.deliveryCategory, (dc) => dc === 'Alma-E');
            if (eDelCategory !== -1) {
                delivery.deliveryCategory.splice(eDelCategory, 1);
            }
            let availability = findIndex(delivery.availability, (av) => av === 'not_restricted');
            if (availability !== -1) {
                delivery.availability.splice(availability, 1);
            }
            let dDelCategory = findIndex(delivery.deliveryCategory, (dc) => dc === 'Alma-D');
            if (dDelCategory !== -1) {
                delivery.deliveryCategory.splice(dDelCategory, 1);
            }
            return;
        }
        for (let service of eDelivery.electronicServices){
            service['isFromEDelivery'] = true;
        }
        if (isAlreadyCalculated) {
            let currentServices = get(item,'delivery.electronicServices', []);
            let nonEDeliveryServices = currentServices.filter((service)=>!service['isFromEDelivery']);
            item.delivery.electronicServices = nonEDeliveryServices.concat(eDelivery.electronicServices);
            item.delivery.electronicServices = uniqBy(item.delivery.electronicServices, "ilsApiId");
            return;
        }
        this.updateLinks(item, eDelivery);
        if (delivery.GetIt1 === null) {
            item.delivery.electronicServices = eDelivery.electronicServices;
            item.delivery.GetIt1 = eDelivery.GetIt1;
            item.delivery.serviceMode = eDelivery.serviceMode;
            item.delivery.availabilityLinks = eDelivery.availabilityLinks;
            item.delivery.consolidatedCoverage = eDelivery.consolidatedCoverage;
        	item.delivery.electronicContextObjectId = eDelivery.electronicContextObjectId;
            return;
        }
        delivery.electronicServices = eDelivery.electronicServices;
        if (delivery.availabilityLinks){
        	delivery.availabilityLinks.unshift(eDelivery.availabilityLinks[0]);
        }
        delivery.displayedAvailability = eDelivery.displayedAvailability;
        delivery.consolidatedCoverage = eDelivery.consolidatedCoverage;
        if(eDelivery.GetIt1.length) {
            delivery.GetIt1.unshift(eDelivery.GetIt1[0]);
        }
        delivery.electronicContextObjectId = eDelivery.electronicContextObjectId;
        this.fixRelatedRecordEdelivery(delivery, eDelivery);
    }

    private fixRelatedRecordEdelivery(delivery, eDelivery) {
        if (!eDelivery.GetIt1 || !delivery.deliveryCategory) {
            return;
        }
        let indexOfAlmaE = eDelivery.GetIt1.findIndex(item => item.category === 'Alma-E');
        let indexOfAlmaE_temp = delivery.deliveryCategory.indexOf('Alma-E-temp');
        if (indexOfAlmaE < 0 || indexOfAlmaE_temp < 0) {
            return;
        }
        delivery.deliveryCategory[indexOfAlmaE_temp] = 'Alma-E';
        delivery.availability.push(eDelivery.availability[indexOfAlmaE]);
        delivery.serviceMode.push(eDelivery.serviceMode[indexOfAlmaE]);
    }

    private updateGoogleScholarUrls(item) {
        if (this.isEsploroRecord(item)){
            this.updateGoogleScholarUrlsForEsploro(item);
        } else {
            this.updateGoogleScholarUrlsForDigital(item);
        }
    }

    private updateGoogleScholarUrlsForEsploro(item) {
        if (item.delivery) {
            if (item.delivery.electronicServices && item.delivery.electronicServices.length > 0){
                if (item.delivery.electronicServices[0].pdfFilesUrl &&
                        item.delivery.electronicServices[0].pdfFilesUrl.length > 0){
                    this.addMeta("citation_pdf_url", item.delivery.electronicServices[0].pdfFilesUrl[0]);
                }
            }
        }
    }

    private updateGoogleScholarUrlsForDigital(item) {
        if (item.delivery) {
            let url = this.$location.url();
            if (url.includes("tags=scholar")) {
                for (let i in item.delivery.electronicServices) {
                    if (item.delivery.electronicServices[i].pdfFilesUrl) {
                        for (let pdfFileUrl of item.delivery.electronicServices[i].pdfFilesUrl) {
                            this.addMeta("citation_pdf_url", pdfFileUrl);
                        }
                    }
                }
            }
        }
    }

    private addMeta(name, content) {
        if (content === undefined) {
            return;
        }
        let meta = document.createElement("META");
        meta.setAttribute("name", name);
        meta.setAttribute("content", content);
        document.head.appendChild(meta);
    }

    private updatePhysicalServiceIdAndLinks(item, resp) {
        let delivery = item.delivery;
        if (!delivery || resp == null) {
            return;
        }
        delivery.physicalServiceId = resp.physicalServiceId;
        if(!this.isElectronicWithResourceSharing(_get(item,'delivery',[]))){
            this.updateLinks(item, resp);
        }
    }

    /*
        When we have both Viewit and howovp it means we either have the customer setting 'discovery_display_resource_sharing_when_electronic_available' enabled
        or we have a record with only auxiliary representations. This method should return true only for the first case.
    */
    public isElectronicWithResourceSharing(delivery){
        return (_get(delivery, 'serviceMode',[]).indexOf("howovp") > -1 && _get(delivery, 'serviceMode',[]).indexOf("Viewit") > -1) 
            && !_get(delivery, 'digitalAuxiliaryMode', false);
    }

    private updateLinks(item, resp) {
        let delivery = item.delivery;
        if ((delivery.link === undefined || delivery.link === null) && resp.link) {
            item.delivery = resp.link;
            return;
        }
        if (resp.link) {
            let idx = delivery.link.length;
            resp.link = resp.link.map((item, index, array) => this.updateIndex(item, index, idx));
            item.delivery.link = union(delivery.link, resp.link);
        }
    }

    private updateIndex(item, index, idx) {
        item['@id'] = '_:' + (index + idx);
        return item;
    }

    private getLinkByAction(item, action) {
        let getItArray = this.getGetItObject(item, action);
        return getItArray && (getItArray.length > 0) ? getItArray : [];
    }

    private getGetItObject(item, action) {
        let getItArray = [];
        let filterFunction = null;
        switch (action) {
            case 'getit_link1':
                if (!item.delivery || !item.delivery.GetIt1) {
                    return null;
                }
                getItArray = item.delivery.GetIt1.links || item.delivery.GetIt1;
                break;
            case 'getit_link2':
                getItArray = item.delivery.GetIt2;
                break;

            default:
                return null;
        }

        return getItArray;
    }

    private parseServicesWithConfiguration(item, type) {
        if (type === 'getit_link1') {
            return this.buildGetitServicesArray(item, type);
        }
        if (type === 'getit_link2') {
            return this.buildGetit2ServicesArray(item, type);
        }

        return this.servicesDirectives[type];
    }

    private handleCitationTrialsAndTimesCitedVisibilityForSuprima(services, citationTrailsFullviewLinkService, timesCitedService) {
        let citationTrialAndTimesCitedConfigured = true;
        if (services.filter(function (e) {
            return e.serviceName == 'citationTrails';
        }).length > 0) {
            citationTrailsFullviewLinkService.setShowCitationTrialForSuprima(true);
        } else {
            citationTrailsFullviewLinkService.setShowCitationTrialForSuprima(false);
            citationTrialAndTimesCitedConfigured = false;
        }

        if (services.filter(function (e) {
            return e.serviceName == 'timesCited';
        }).length > 0) {
            timesCitedService.setShowTimesCitedForSuprima(true);
        } else {
            timesCitedService.setShowTimesCitedForSuprima(false);
            citationTrialAndTimesCitedConfigured = false;
        }

        //To prevent from the citations to appear twice
        if (citationTrialAndTimesCitedConfigured) {
            services = services.filter(function (e) {
                return e.serviceName != 'timesCited';
            });
        }

        return services;
    }

    public getServicesDirectives() {
        return this.servicesDirectives;
    }

    public setServiceTitle(serviceName, label) {
        this.servicesDirectives[serviceName].title = label;
    }

    public addServiceDirective(serviceName, serviceDirective) {
        this.servicesDirectives[serviceName] = serviceDirective;
    }

    public disableService(serviceName) {
        this.servicesDirectives[serviceName].isDisabled = true;
    }

    public calculatePrimaViewItDone() {
        return this._calculatePrimaViewItDeliveryDone && this.isCalculatePcDeliveryDone();
    }

    set calculatePrimaViewItDeliveryDone(isDone) {
        this._calculatePrimaViewItDeliveryDone = isDone;
    }

    // get the index where the conf of service comes after promise resolved need to be inserted in tabsToDisplay
    //orderedTabs - configuration of the original tabsOrder
    private getInsertIndexLateService(orderedTabs,tabsToDisplay,conf): number{
        let indexToInsert = tabsToDisplay.length; //default index - the end of the array
        let serviceName = _get(conf,'serviceName');
        let hasBefore = false;
        let indexOfLateService = findIndex(orderedTabs, (o) => { return _get(o,'serviceName') === serviceName;});
        // insert the late service after the first service it finds in the orginal tabs order
        // if there is not any, insert it before the next service in the original tabs order
        tabsToDisplay.forEach((value, index, arr) => {
            let serviceIndex = findIndex(orderedTabs, (o) => { return _get(o,'serviceName') === _get(value,'serviceName'); });
            serviceIndex = serviceIndex === -1 ? tabsToDisplay.length : serviceIndex;
            if(serviceIndex <= indexOfLateService){
                indexToInsert = index + 1;
                hasBefore = true;
            }else if(!hasBefore && serviceIndex < tabsToDisplay.length){
                indexToInsert = index;
                hasBefore = true;
            }
        });
        return indexToInsert;
    }

    private isViewItDeliveryCategory(delCategory: string) : boolean {
        return this.viewitDeliveryCategories.indexOf(delCategory) > -1;
    }

    private getViewItDeliveryIndex(delCategories: [string]) : number {
        for (let category of this.viewitDeliveryCategories){
            let delIndex = delCategories.indexOf(category);
            if (delIndex > -1){
                return delIndex;
            }
        }
        console.error('getit array and delivery category did not match for viewit');
        return -1;
    }

    public rapidoSAServices(): Array<string> {
        let rapidoSAServices: Array<string> = ['Viewit', 'rapidoOffer', 'searchWithinJournal', 'details', 'action_list', 'brief', 'ovp', 'howovp', 'ovl'];
        return rapidoSAServices;
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/fullView.service.ts